import { render, staticRenderFns } from "./MoveToArchiveButton.vue?vue&type=template&id=4fcbfbd2&"
import script from "./MoveToArchiveButton.vue?vue&type=script&lang=js&"
export * from "./MoveToArchiveButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports